import React from 'react'
import {
  ConvertKitTag,
  useTestTag,
} from 'organization/Event/Services/Apps/ConvertKit/Config/Tags'
import {CONVERT_KIT} from 'organization/Event/Services/ServicesProvider'
import TestTagButton from 'organization/Event/Form/TestTagButton'

export default function TestConvertKitTagButton(props: {
  tag: ConvertKitTag | null
}) {
  const addTag = useTestTag()
  return (
    <TestTagButton tag={props.tag} integration={CONVERT_KIT} addTag={addTag} />
  )
}
